import { defineStore } from 'pinia'
import i18n from '@/i18n'

export const useI18nStore = defineStore('i18n', {
  state: () => ({
    currentLocale: 'en-US',
    supportedLocales: ['zh-CN', 'en-US'],
    isLoading: false
  }),
  
  getters: {
    locale: (state) => state.currentLocale,
    localeDisplayName: (state) => {
      const names = {
        'zh-CN': '简体中文',
        'en-US': 'English',
      }
      return names[state.currentLocale]
    }
  },
  
  actions: {
    async setLocale(locale) {
      if (!this.supportedLocales.includes(locale)) {
        console.error(`Unsupported locale: ${locale}`)
        return
      }
      
      const previousLocale = this.currentLocale
      this.isLoading = true
      
      try {
        i18n.global.locale.value = locale
        this.currentLocale = locale
        this.saveToStorage(locale)
        this.updateHtmlLang(locale)
      } catch (error) {
        console.error('Failed to set locale:', error)
        // 回滚到之前的语言设置
        i18n.global.locale.value = previousLocale
        this.currentLocale = previousLocale
        throw error
      } finally {
        this.isLoading = false
      }
    },
    
    loadFromStorage() {
      try {
        const saved = localStorage.getItem('user_preferred_locale')
        if (saved && this.supportedLocales.includes(saved)) {
          return saved
        }
        return null
      } catch (error) {
        console.warn('Failed to load locale from storage:', error)
        return null
      }
    },
    
    saveToStorage(locale) {
      try {
        localStorage.setItem('user_preferred_locale', locale)
      } catch (error) {
        console.warn('Failed to save locale to storage:', error)
        // 继续执行，不抛出错误
      }
    },
    
    detectBrowserLocale() {
      const browserLang = navigator.language || navigator.userLanguage
      
      // 处理中文变体
      if (browserLang.startsWith('zh')) {
        return 'zh-CN'
      }
      
      // 匹配支持的语言
      for (const locale of this.supportedLocales) {
        if (browserLang.startsWith(locale.split('-')[0])) {
          return locale
        }
      }
      
      return 'en-US' // 默认回退
    },
    
    initializeLocale() {
      // 优先级：localStorage > 浏览器检测 > 默认值
      const savedLocale = this.loadFromStorage()
      const locale = savedLocale || this.detectBrowserLocale()
      this.setLocale(locale)
    },
    
    updateHtmlLang(locale) {
      document.documentElement.setAttribute('lang', locale)
    }
  }
})
